import React from 'react';
import { Search } from 'lucide-react';
import { cn } from './Button';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  wrapperClassName?: string;
}
export function Input({
  className,
  icon,
  wrapperClassName,
  ...props
}: InputProps) {
  return <div className={cn('relative', wrapperClassName)} data-id="element-1123">
      {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-1124">
          {icon}
        </div>}
      <input className={cn('flex h-10 w-full rounded-xl border border-slate-700/60 bg-[#1E293B] px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-pink-500/30 focus:border-pink-500/40 disabled:cursor-not-allowed disabled:opacity-50 transition-colors', icon && 'pl-10', className)} {...props} data-id="element-1125" />
    </div>;
}